module.exports = __webpack_public_path__ + "static/media/2000.9386827.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/2000.mp3
// module id = b1+O
// module chunks = 1